import { Box } from "@chakra-ui/react";

export function ErrorBox({ children }: { children: React.ReactNode }) {
  return (
    <Box h="100vh" w="100vw" mt={5} px={10}>
      {children}
    </Box>
  );
}
